export const CLEAR_TEXT_KEY = 'cleartext';
export const CLEAR_TEXT_KEY_A11Y = 'cleartexta11y';
// Query params to preserve when we clean all filters
export const BASE_QUERY_PARAMS = ['keyword'];
